export function columnShouldBeNumeric(columnName: string): boolean {
  const contains = [
    "total",
    "quantity",
    "qty",
    "budget",
    "delta",
    "area",
    "count",
    "gsf",
    "nsf",
    "salary",
    "allowance",
    "rate",
    "markup",
  ];

  // Suffix match, to check if the column name ends with a known string
  const endsWithMatches = [
    "_$",
    "_$$",
    "_area",
    "_sf",
    "_sm",
    "_length",
    "_height",
    "_lf",
    "_lm",
    "_uc",
    "_rate",
    "_lf",
    "_cost",
    "_week",
    "_value",
    "_work",
  ];

  const hasPartialMatch = contains.some((partial) => columnName.includes(partial));
  const endsWithMatch = endsWithMatches.some((suffix) => columnName.endsWith(suffix));

  return hasPartialMatch || endsWithMatch;
}

export function columnShouldBeDate(columnName: string): boolean {
  const contains = [
    "created_at",
    "updated_at",
    "deleted_at",
    "precon_start",
    "precon_finish",
    "construction_start",
    "construction_finish",
  ];

  const endsWithDateMatches = ["_date"];

  const hasPartialDateMatch = contains.some((partial) => columnName.includes(partial));
  const endsWithDateMatch = endsWithDateMatches.some((suffix) => columnName.endsWith(suffix));

  return hasPartialDateMatch || endsWithDateMatch;
}

export function valuesAreCalendarDates(values: unknown[]): boolean {
  const present = values.filter((value) => value !== null && value !== undefined && value !== "");
  return present.length > 0 && present.every((value) => typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value));
}

export function getColumnLetter(colIndex: number): string {
  let columnLetter = "";
  let dividend = colIndex + 1; // Excel columns are 1-indexed

  while (dividend > 0) {
    let modulo = (dividend - 1) % 26;
    columnLetter = String.fromCharCode(65 + modulo) + columnLetter;
    dividend = Math.floor((dividend - modulo) / 26);
  }

  return columnLetter;
}

export const getColumnIndexFromAddress = (address: string): number => {
  const colLetters = address.match(/[A-Z]+/g)?.[0] || "A";
  return colLetters.split("").reduce((sum, char) => sum * 26 + (char.charCodeAt(0) - 64), 0) - 1;
};

export const excelNamesMatch = (a: string, b: string): boolean => a.toLowerCase() === b.toLowerCase();
